<template>
  <div class="waitingForStorage">
    <div class="searchTop">
      <van-row type="flex" align="center" class="search-top-row">
        <van-col class="colItemScan" @click="onScan">
          <van-image width="25" height="25" :src="scanIcon"></van-image>
        </van-col>
        <van-col class="colItem1">
          <van-search
            v-model="searchText"
            show-action
            shape="round"
            background="transparent"
            :placeholder="getPlaceHolder()"
          >
            <template #action>
              <div @click="onSearch">{{ $t.meta.search }}</div>
            </template>
          </van-search>
        </van-col>
        <van-col class="colItem2">
          <div :class="isFilter() ? 'isFilter' : ''">
            <span @click="showFilter = true">{{ $t.meta.filter }}</span>
          </div>
        </van-col>
      </van-row>
    </div>

    <van-tabs
      v-model="menuState"
      @change="stateChanged"
      title-active-color="#009ed4"
      color="#009ed4"
      swipeable
      :ellipsis="false"
    >
      <van-tab
        v-for="(menu, index) in menuList"
        :key="index"
        :title="menu.title + (menu.count > 0 ? ' ' + menu.count : '')"
        :name="menu.name"
      >
        <van-list
          class="list"
          v-model="loading"
          :finished="finished"
          :finished-text="$t.meta.noMore"
          :error.sync="error"
          :error-text="errorText"
          @load="getList(page + 1)"
        >
          <div class="list-container" v-for="(item, index) in tableData" :key="index">
            <div class="container">
              <div class="left">
                <div class="list-item">
                  {{ $t.onlineOrder.postNumber }}：{{ item.ExpressNumber }}
                </div>
                <div class="list-item">
                  {{ $t.onlineOrder.goodsName }}：{{ item.CargoName }}
                </div>
                <div class="list-item">
                  {{ $t.onlineOrder.goodsValue }}：{{ item.GoodsValue }}
                  {{ item.Currency }}
                </div>
                <div class="list-item">
                  {{ $t.onlineOrder.cargoQuantity }}：{{ item.CargoQuantity }}
                  {{ item.QuantityUnit }}
                </div>
                <div class="list-item">
                  {{ $t.onlineOrder.customerNumber }}：{{ item.CustomerNumber }}
                </div>
                <div class="list-item">
                  {{ $t.onlineOrder.customerName }}：{{ item.CustomerName }}
                </div>
                <div class="list-item">
                  {{ $t.onlineOrder.countryName }}：{{ item.CountryName }}
                </div>
                <div class="list-item">
                  {{ $t.onlineOrder.cargoCategorySn }}：{{ item.CargoCategory }}
                </div>
                <div class="list-item">
                  {{ $t.onlineOrder.orderDate }}：{{ item.CreateTime }}
                </div>
                <div class="list-item">
                  {{ $t.onlineOrder.isUnpack }}：<van-icon
                    name="success"
                    v-if="item.IsUnpack"
                  />
                </div>
              </div>
              <div class="right">
                <div class="images">
                  <van-image
                    width="88"
                    height="88"
                    fit="cover"
                    @click="imagePreview(item.ProductPictureList)"
                    :src="imgUrlFilter(item.ProductPictureList[0])"
                    v-if="item.ProductPictureList && item.ProductPictureList.length > 0"
                  />
                  <span v-else>{{ $t.onlineOrder.noImage }}</span>
                </div>
              </div>
              <div class="buttons">
                <van-button
                  class="primary-btn"
                  size="small"
                  type="primary"
                  @click="dialogShow(item)"
                  >{{ $t.onlineOrder.putInStorage }}</van-button
                >

                <van-button
                  class="search-btn"
                  size="small"
                  type="primary"
                  @click="onUnpack(item.COId, item.CargoQuantity)"
                  >{{ $t.onlineOrder.unpackButton }}</van-button
                >

                <van-button
                  class="danger-btn"
                  size="small"
                  type="primary"
                  @click="dialogDeleteShow(item.COId)"
                  >{{ $t.meta.delete }}</van-button
                >
              </div>
            </div>
          </div>
        </van-list>
      </van-tab>
    </van-tabs>

    <van-popup
      v-model="showFilter"
      position="bottom"
      :style="{ height: '80%', width: '100%' }"
    >
      <div class="popup-header">{{ $t.meta.allFilter }}</div>
      <van-form>
        <div class="radio-label">{{ $t.meta.searchType }}</div>
        <van-radio-group v-model="searchType" direction="horizontal">
          <van-radio
            :name="item.value"
            v-for="(item, index) in searchTypeOptions"
            :key="index"
            >{{ item.text }}</van-radio
          >
        </van-radio-group>

        <van-field
          clickable
          readonly
          :value="selectedCountry.text"
          :label="$t.onlineOrder.countryName"
          :placeholder="$t.meta.select"
          @click="onShowEmit('showWaitingForStorageCountry')"
        />

        <van-field
          clickable
          readonly
          :value="selectedService.text"
          :label="$t.onlineOrder.cargoCategorySn"
          :placeholder="$t.meta.select"
          @click="onShowEmit('showWaitingForStorageService')"
        />
      </van-form>
      <div class="popup-footer">
        <van-button class="reset" type="info" block square @click="filterReset">{{
          $t.meta.reset
        }}</van-button>

        <van-button class="confirm" type="primary" block square @click="filterSubmit">{{
          $t.meta.confirm
        }}</van-button>
      </div>
    </van-popup>

    <van-dialog
      :title="$t.onlineOrder.dialogTitle"
      width="90%"
      v-model="dialogVisible"
      @cancel="dialogVisible = false"
      @confirm="dialogConfirm"
      :cancel-button-text="$t.meta.close"
      :confirm-button-text="$t.meta.confirm"
      :show-cancel-button="true"
      :show-confirm-button="true"
      :className="
        dialogForm.IsCompleteOrderGoodsValue
          ? 'waitingForStorage-dialog1'
          : 'waitingForStorage-dialog2'
      "
      :before-close="
        (action, done) => {
          done(false);
        }
      "
    >
      <slot name="default">
        <div
          :class="
            dialogForm.IsCompleteOrderGoodsValue
              ? 'waitingForStorage-alert1'
              : 'waitingForStorage-alert2'
          "
        >
          <van-form label-width="100px">
            <van-field
              v-model="dialogForm.NumberPackages"
              :label="$t.onlineOrder.numberPackages"
              :placeholder="$t.meta.input"
              required
            />

            <van-field
              v-model="dialogForm.Volume"
              :label="$t.onlineOrder.volume + ' ( cbm )'"
              :placeholder="$t.meta.input"
              required
            />

            <van-field
              v-model="dialogForm.Weight"
              :label="$t.onlineOrder.weight + ' ( KG )'"
              :placeholder="$t.meta.input"
              required
            />

            <span v-if="dialogForm.IsCompleteOrderGoodsValue">
              <van-field
                v-model="dialogForm.GoodsValue"
                :label="$t.onlineOrder.goodsValue"
                :placeholder="$t.meta.input"
                required
              />

              <van-field
                v-model="dialogForm.Currency"
                :label="$t.meta.currency"
                @click="pickerShow('showCurrencyPicker')"
                :placeholder="$t.meta.select"
                clickable
                readonly
                required
              />

              <van-field
                v-model="dialogForm.PTIdStr"
                :label="$t.onlineOrder.productCategory"
                :placeholder="$t.meta.select"
                @click="onShowEmit('showWaitingForStorageProductCategory')"
                clickable
                readonly
                required
                v-if="productTaxList.length > 0"
              />

              <van-field
                v-model="dialogForm.TaxFeebearingPartyStr"
                :label="$t.onlineOrder.taxFeebearingParty"
                :placeholder="$t.meta.select"
                @click="pickerShow('showTaxFeePicker')"
                clickable
                readonly
                required
              />
            </span>
          </van-form>
        </div>
      </slot>
    </van-dialog>

    <van-dialog
      :title="$t.meta.notice"
      width="90%"
      v-model="showDeleteDialog"
      @confirm="deleteCustomerOrder"
      @cancel="showDeleteDialog = false"
      :confirm-button-text="$t.meta.confirm"
      :cancel-button-text="$t.meta.cancel"
      :show-cancel-button="true"
      :show-confirm-button="true"
    >
      <div style="margin: 20px; text-align: center">
        {{ $t.meta.deleteConfirm }}
      </div>
    </van-dialog>

    <van-dialog
      :title="$t.onlineOrder.unpackTitle"
      width="90%"
      v-model="dialogUnpackVisible"
      @cancel="dialogUnpackClose"
      @confirm="customerOrderUnpack"
      :cancel-button-text="$t.meta.cancel"
      :confirm-button-text="$t.meta.confirm"
      :show-cancel-button="true"
      :show-confirm-button="true"
      className="waitingForStorage-dialog1"
      :before-close="
        (action, done) => {
          done(false);
        }
      "
    >
      <slot name="default">
        <div class="waitingForStorage-alert1">
          <div class="multi-table">
            <van-field
              v-model="dialogUnpackForm.totalQty"
              :label="$t.onlineOrder.totalQty"
              disabled
            />

            <van-field
              v-model="dialogUnpackForm.splitOrderQuantity"
              :label="$t.onlineOrder.unpackQty"
              label-class="number-label"
              :placeholder="$t.meta.input"
              oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+5)}"
              required
              :rules="formRule"
            >
              <template #button>
                <van-button size="small" type="info" @click="onUnpackConfirm">{{
                  $t.meta.confirm
                }}</van-button>
              </template>
            </van-field>

            <div
              v-for="(item, index) in dialogUnpackForm.splitOrderQuantityList"
              :key="index"
            >
              <div class="multi-table-header">
                <div class="multi-table-title">
                  {{ $t.onlineOrder.packageSn }} {{ item.id }}
                </div>
              </div>

              <van-field
                v-model="item.number"
                :label="$t.onlineOrder.cargoQuantity"
                :placeholder="$t.meta.input"
                oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+5)}"
              />
            </div>
          </div>
        </div>
      </slot>
    </van-dialog>

    <option-list
      event="showWaitingForStorageCountry"
      :options="countryList"
      @onSelect="countryConfirm"
    ></option-list>

    <option-list
      event="showWaitingForStorageService"
      :options="freightList"
      @onSelect="freightConfirm"
    ></option-list>

    <option-list
      event="showWaitingForStorageProductCategory"
      :options="productTaxList"
      @onSelect="productCategoryConfirm"
    ></option-list>

    <van-popup v-model="showCurrencyPicker" round position="bottom">
      <van-picker
        :title="$t.meta.currency"
        show-toolbar
        :columns="currencyList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="currencyConfirm($event)"
        @cancel="showCurrencyPicker = false"
      />
    </van-popup>

    <van-popup v-model="showTaxFeePicker" round position="bottom">
      <van-picker
        :title="$t.onlineOrder.taxFeebearingParty"
        show-toolbar
        :columns="taxFeebearingPartyList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="taxFeeConfirm"
        @cancel="showTaxFeePicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
import OptionList from "@components/optionList/OptionList.vue";
import {
  List,
  Tab,
  Tabs,
  Row,
  Col,
  Search,
  Button,
  Form,
  Field,
  Popup,
  Picker,
  Radio,
  RadioGroup,
  Image,
  Icon,
} from "vant";

import Vue from "vue";
Vue.use(List)
  .use(Tab)
  .use(Tabs)
  .use(Row)
  .use(Col)
  .use(Search)
  .use(Button)
  .use(Form)
  .use(Field)
  .use(Popup)
  .use(Picker)
  .use(Radio)
  .use(RadioGroup)
  .use(Image)
  .use(Icon);

export default {
  name: "waitingForStorage",
  components: {
    OptionList,
  },
  data() {
    return {
      scanIcon: require("@/assets/img/home/scan.png"),
      menuState: this.$route.query.state ? this.$route.query.state : 1,
      menuList: [
        {
          title: this.$t.onlineOrder.tab1,
          name: 1,
          count: 0,
        },
      ],
      tableData: [],
      page: 0,
      pageSize: 10,
      loading: false,
      finished: false,
      error: false,
      errorText: "",
      //filter
      searchText: "",
      searchType: 1,
      searchTypeOptions: [
        {
          text: this.$t.onlineOrder.postNumber,
          value: 1,
        },
        {
          text: this.$t.onlineOrder.goodsName,
          value: 2,
        },
        {
          text: this.$t.onlineOrder.customerNumber,
          value: 3,
        },
        {
          text: this.$t.onlineOrder.customerName,
          value: 4,
        },
      ],
      showFilter: false,
      selectedCountry: { text: "", value: null },
      selectedService: { text: "", value: null },
      countryList: [],
      freightList: [],
      currencyList: [],
      productTaxList: [],
      taxFeebearingPartyList: [
        {
          text: this.$t.onlineOrder.shipperSn,
          value: 1,
        },
        {
          text: this.$t.onlineOrder.consigneeSn,
          value: 2,
        },
      ],
      //picker
      showWaitingForStorageCountry: false,
      showWaitingForStorageService: false,
      showCurrencyPicker: false,
      showWaitingForStorageProductCategory: false,
      showTaxFeePicker: false,
      //订单入库
      dialogVisible: false,
      dialogForm: {
        COId: null,
        NumberPackages: "",
        Volume: "",
        Weight: "",
        IsCompleteOrderGoodsValue: false,
        GoodsValue: null,
        Currency: "",
        SCId: null,
        PTId: null,
        PTIdStr: "",
        TaxFeebearingParty: null,
        TaxFeebearingPartyStr: "",
      },
      //删除订单
      showDeleteDialog: false,
      dialogDeleteId: null,
      //拆包
      dialogUnpackVisible: false,
      dialogUnpackForm: {
        COId: null,
        totalQty: null,
        splitOrderQuantity: null,
        splitOrderQuantityList: [],
      },
      formRule: [
        {
          required: true,
          message: this.$t.meta.require,
        },
      ],
    };
  },
  watch: {
    menuState() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.tableData = [];
      this.getList(1);
    },
    $route(to, from) {
      if (this.$route.query && to && from) {
        const { SearchText } = this.$route.query;
        if (SearchText) {
          this.searchText = SearchText;
          this.loading = true;
          this.finished = false;
          this.error = false;
          this.tableData = [];
          this.getList(1);
        }
      }
    },
  },
  created() {
    this.getFreightPriceListByPage();
  },
  methods: {
    onUnpack(id, qty) {
      this.dialogUnpackVisible = true;
      this.dialogUnpackForm.COId = id;
      this.dialogUnpackForm.totalQty = qty;
    },
    onUnpackConfirm() {
      this.dialogUnpackForm.splitOrderQuantityList = [];
      for (var i = 1; i <= this.dialogUnpackForm.splitOrderQuantity; i++) {
        this.dialogUnpackForm.splitOrderQuantityList.push({
          id: i,
          number: null,
        });
      }
    },
    dialogUnpackClose() {
      this.dialogUnpackVisible = false;
      this.dialogUnpackForm = {
        COId: null,
        totalQty: null,
        splitOrderQuantity: null,
        splitOrderQuantityList: [],
      };
    },
    customerOrderUnpack() {
      this.$commonMethod.showLoading();
      var splitOrderQuantityList = [];
      for (var item of this.dialogUnpackForm.splitOrderQuantityList) {
        splitOrderQuantityList.push(parseInt(item.number));
      }
      var param = {
        COId: this.dialogUnpackForm.COId,
        SplitOrderQuantityList: splitOrderQuantityList,
      };
      this.$api.onlineOrderManagement
        .customerOrderUnpack(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.dialogUnpackVisible = false;
          this.initList();
          this.getList(1);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    onScan() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.scanToPage, {
        options: {
          baseColor: "#009ed4",
          choosePhotoEnable: "true",
          flashlightEnable: "true",
          title: this.$t.onlineOrder.scanTitle1,
          describe: this.$t.meta.scanDes,
          choosePhotoBtnTitle: this.$t.meta.scanButton,
        },
        path: "waitingForStorage",
        errorText: this.$t.meta.scanError1,
        authText: this.$t.meta.scanError2,
      });
    },
    deleteCustomerOrder() {
      this.$commonMethod.showLoading();
      var param = {
        COId: this.dialogDeleteId,
      };
      this.$api.onlineOrderManagement
        .deleteCustomerOrder(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.showDeleteDialog = false;
          this.initList();
          this.getList(1);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    dialogDeleteShow(id) {
      this.dialogDeleteId = id;
      this.showDeleteDialog = true;
    },
    dialogConfirm() {
      this.$commonMethod.showLoading();
      var param = {
        COId: this.dialogForm.COId,
        NumberPackages: this.dialogForm.NumberPackages,
        Volume: this.dialogForm.Volume,
        Weight: this.dialogForm.Weight,
      };
      if (this.dialogForm.IsCompleteOrderGoodsValue) {
        param.GoodsValue = this.dialogForm.GoodsValue;
        param.SCId = this.dialogForm.SCId;
        param.Currency = this.dialogForm.Currency;
        param.PTId = this.dialogForm.PTId;
        param.TaxFeebearingParty = this.dialogForm.TaxFeebearingParty;
      }
      this.$api.onlineOrderManagement
        .editCustomerOrderPutInStorage(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.dialogVisible = false;
          this.initList();
          this.getList(1);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    dialogShow(item) {
      this.dialogForm.COId = item.COId;
      this.dialogForm.IsCompleteOrderGoodsValue = item.IsCompleteOrderGoodsValue;
      if (this.dialogForm.IsCompleteOrderGoodsValue) {
        this.getDialogOptions(item.FPId, item.FPDId).then((success) => {
          if (success) {
            this.dialogVisible = true;
          }
        });
      } else {
        this.dialogVisible = true;
      }
    },
    getDialogOptions(FPId, FPDId) {
      return new Promise((resolve) => {
        this.$commonMethod.showLoading();
        Promise.all([this.getCurrencyList(), this.getProductTaxList(FPId, FPDId)])
          .then((success) => {
            if (success) {
              resolve(true);
            }
            this.$commonMethod.hideLoading();
          })
          .catch(() => {
            this.$commonMethod.hideLoading();
          });
      });
    },
    getCurrencyList() {
      return new Promise((resolve) => {
        this.$api.financialManagement
          .getSystemAvailableCurrencyList()
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text: item.CurrencySn,
                value: item.SCId,
              };
              result.push(data);
            });
            this.currencyList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    getProductTaxList(FPId, FPDId) {
      return new Promise((resolve) => {
        var param = {
          FPId: FPId,
        };
        this.$api.onlineOrderManagement
          .loadFreightPriceInfo(param)
          .then((res) => {
            var result = [];
            res.data.DetailList.forEach((item) => {
              if (item.ProductTaxList.length > 0) {
                for (var product of item.ProductTaxList) {
                  if (product.FPDId == FPDId) {
                    let data = {
                      text: product.ProductCategory,
                      value: product.PTId,
                    };
                    result.push(data);
                  }
                }
              }
            });
            this.productTaxList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    imagePreview(images) {
      var pictureList = [];
      for (var image of images) {
        pictureList.push(this.imgUrlFilter(image));
      }
      this.$commonEnv.commonAction(this.$commonEnv.actionType.picturePreview, {
        pictureList: pictureList,
        startPosition: 0,
      });
    },
    getPlaceHolder() {
      var search = this.searchTypeOptions.find((c) => c.value == this.searchType);
      if (search) {
        return search.text;
      } else {
        return this.$t.meta.searchText;
      }
    },
    onSearch() {
      this.initList();
      this.getList(1);
    },
    isFilter() {
      if (this.selectedCountry.value || this.selectedService.value) {
        return true;
      } else {
        return false;
      }
    },
    filterReset() {
      this.searchText = "";
      this.searchType = 1;
      this.selectedCountry = { text: "", value: null };
      this.selectedService = { text: "", value: null };
      this.freightList = [];
      this.initList();
      this.getList(1);
    },
    filterSubmit() {
      this.initList();
      this.getList(1);
    },
    initList() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.showFilter = false;
      this.tableData = [];
    },
    pickerShow(pickerName) {
      this[pickerName] = true;
    },
    countryConfirm(e) {
      this.selectedCountry.text = e.text;
      this.selectedCountry.value = e.value;
      this.showWaitingForStorageCountry = false;
      this.selectedService = { text: "", value: null };
      this.loadFreightPriceInfo(e.value);
      this.$forceUpdate();
    },
    freightConfirm(e) {
      this.selectedService.text = e.text;
      this.selectedService.value = e.value;
      this.showWaitingForStorageService = false;
      this.$forceUpdate();
    },
    productCategoryConfirm(e) {
      this.dialogForm.PTIdStr = e.text;
      this.dialogForm.PTId = e.value;
      this.showWaitingForStorageProductCategory = false;
      this.$forceUpdate();
    },
    taxFeeConfirm(item) {
      this.dialogForm.TaxFeebearingPartyStr = item.text;
      this.dialogForm.TaxFeebearingParty = item.value;
      this.showTaxFeePicker = false;
    },
    currencyConfirm(e) {
      if (!e) {
        return;
      }
      this.dialogForm.Currency = e.text;
      this.dialogForm.SCId = e.value;
      this.showCurrencyPicker = false;
    },
    getFreightPriceListByPage() {
      return new Promise((resolve) => {
        this.$api.onlineOrderManagement
          .getFreightPriceListByPage()
          .then((res) => {
            var result = [];
            res.data.Data.forEach((item) => {
              let data = {
                text: item.CountryName,
                value: item.FPId,
              };
              result.push(data);
            });
            this.countryList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    loadFreightPriceInfo(id) {
      return new Promise((resolve) => {
        this.$commonMethod.showLoading();
        var param = {
          FPId: id,
        };
        this.$api.onlineOrderManagement
          .loadFreightPriceInfo(param)
          .then((res) => {
            var result = [];
            res.data.DetailList.forEach((item) => {
              let data = {
                text: item.CargoCategory,
                value: item.FPDId,
              };
              result.push(data);
            });
            this.freightList = result;
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    onShowEmit(emit) {
      this.$bus.$emit(emit, true);
    },
    stateChanged(state) {
      this.menuState = state;
      this.searchText = "";
    },
    getList(page) {
      var param = {
        PageIndex: page,
        PageSize: this.pageSize,
        ExpressNumber: this.searchType == 1 ? this.searchText : "",
        CargoName: this.searchType == 2 ? this.searchText : "",
        CustomerNumber: this.searchType == 3 ? this.searchText : "",
        CustomerName: this.searchType == 4 ? this.searchText : "",
        FPId: this.selectedCountry.value,
        FPDId: this.selectedService.value,
      };
      var request = null;
      if (this.menuState == 1) {
        request = this.$api.onlineOrderManagement.getCustomerOrderPutInStorageListByPage(
          param
        );
      }
      request
        .then((res) => {
          this.tableData = this.tableData.concat(res.data.Data);
          this.loading = false;
          this.error = false;
          this.errorText = "";

          this.page = res.meta.page;
          this.finished = this.page >= res.meta.lastPage;
        })
        .catch((error) => {
          this.loading = false;
          this.error = true;
          this.errorText = error.message;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.waitingForStorage {
  .searchTop {
    width: 100%;
    background-color: #ffffff;
    .search-top-row {
      width: 100%;
      text-align: center;
      background-color: transparent;
      .colItemScan {
        width: 15%;
        margin: auto;
        text-align: center;
        .van-icon {
          color: #323233;
          font-weight: bold;
        }
      }
      .colItem1 {
        width: 65%;
        text-align: center;
        font-size: 14px;
        .van-search {
          padding: 10px 0px;
          .van-search__content {
            padding: 0px;
            margin-right: 10px;
            .van-cell {
              padding: 5px 8px 5px 8px;
            }
          }
        }
      }
      .colItem2 {
        width: 20%;
        text-align: center;
        font-size: 14px;
        .isFilter {
          color: $-color-primary;
          font-weight: bold;
        }
      }
    }
  }
  .list {
    .list-container {
      font-size: 12px;
      color: #333;
      padding: 10px;
      margin-top: 10px;
      box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);
      .left {
        vertical-align: middle;
        display: inline-block;
        width: 60%;
        .list-item {
          margin-bottom: 10px;
          .van-icon-success {
            color: #01aaa3;
            font-size: 14px;
          }
        }
      }
      .right {
        vertical-align: middle;
        display: inline-block;
        width: 40%;
        .images {
          overflow: hidden;
          vertical-align: middle;
          text-align: center;
          ::v-deep img {
            border-radius: 8px;
          }
        }
      }
      .buttons {
        text-align: right;
        .primary-btn {
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-primary;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .search-btn {
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-green;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .danger-btn {
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-red;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
      }
    }
  }
  .popup-header {
    margin-top: 20px;
    margin-bottom: 10px;
    padding-bottom: 10px;
    text-align: center;
    font-size: 16px;
  }
  .radio-label {
    color: #646566;
    margin-bottom: 10px;
    font-size: 14px;
  }
  .van-radio-group {
    margin-bottom: 20px;
  }
  .van-radio {
    margin-bottom: 10px;
    font-size: 14px;
    ::v-deep .van-radio__label {
      color: #646566;
    }
  }
  .van-form {
    width: 90%;
    margin: auto;
    padding-bottom: 20vw;
    .van-cell:after {
      border: none;
    }
    .van-cell {
      border-bottom: 1px solid #ebedf0;
    }
    .custom-date {
      text-align: center;
      border-bottom: 1px solid #ebedf0;
      padding-bottom: 20px;
      .date-label {
        text-align: left;
        font-size: 14px;
        color: #646566;
        margin-left: 15px;
        margin-bottom: 10px;
        margin-top: 10px;
      }
      .date-btn1 {
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .date-btn2 {
        margin-left: 30px;
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .date-txt {
        margin-top: 20px;
        font-size: 14px;
        color: #999;
        border-radius: 10px;
      }
    }
  }
  .waitingForStorage-dialog1 {
    top: 50% !important;
    .waitingForStorage-alert1 {
      overflow: scroll;
      height: 100vw;
      margin-top: 30px;
      margin-bottom: 30px;
      ::v-deep .number-label {
        line-height: 33px;
      }
      ::v-deep .van-field--disabled {
        .van-field__label,
        .van-field__control {
          color: #646566 !important;
          -webkit-text-fill-color: #646566 !important;
        }
      }
      .van-cell {
        border-bottom: 1px solid #ebedf0;
      }
      .van-cell::after {
        border: none !important;
      }
      .multi-table {
        .multi-table-header {
          padding: 10px 15px;
          background: #1e90ff;
          .multi-table-title {
            font-size: 14px;
            font-family: monospace;
            color: #fff;
            width: 50%;
            display: inline-block;
            vertical-align: middle;
          }
          .multi-table-btn {
            width: 50%;
            display: inline-block;
            text-align: right;
            vertical-align: middle;
            .van-icon {
              font-size: 20px;
              font-weight: bold;
              color: #fff;
            }
          }
        }
      }
    }
  }
  .waitingForStorage-dialog2 {
    top: 50% !important;
    .waitingForStorage-alert2 {
      overflow: scroll;
      margin-top: 30px;
      margin-bottom: 30px;
    }
  }
  .popup-footer {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 100;
    background-color: white;
    padding-bottom: env(safe-area-inset-bottom);
    width: 100%;
    .reset {
      width: 50%;
      display: inline-block;
      color: $-color-primary;
      background: #ffffff;
      border: none;
    }
    .confirm {
      width: 50%;
      display: inline-block;
      color: #ffffff;
      background: $-color-primary;
      border: none;
    }
  }
}
</style>
